import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Toggle from './Toggle';

const NotificationSettingGroup = ({ 
    title, 
    description, 
    options = [], 
    selectedValues = [], 
    onOptionChange,
    disabled = false,
    testID,
}) => {
    const handleToggle = (optionValue, isSelected) => {
        onOptionChange?.(optionValue, !isSelected);
    };

    return (
        <View style={styles.container} testID={testID}>
            <View style={styles.content}>
                <View style={styles.textContainer}>
                    <Text style={styles.title}>{title}</Text>
                    {description && <Text style={styles.description}>{description}</Text>}
                </View>
                <View style={styles.togglesContainer}>
                    {options.map((option) => {
                        const optionValue = typeof option === 'object' ? option.value : option;
                        const optionLabel = typeof option === 'object' ? option.label : option;
                        const isSelected = selectedValues?.includes(optionValue);

                        return (
                            <View key={optionValue} style={styles.toggleRow}>
                                <Toggle
                                    value={isSelected}
                                    onValueChange={() => handleToggle(optionValue, isSelected)}
                                    disabled={disabled}
                                    testID={testID ? `${testID}-${optionValue.toLowerCase()}` : undefined}
                                    accessibilityLabel={`${title}: ${optionLabel}`}
                                />
                                <Text style={styles.toggleLabel}>{optionLabel}</Text>
                            </View>
                        );
                    })}
                </View>
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    container: {
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        paddingVertical: spacing.md + 4,
    },
    content: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: spacing.md + 4,
    },
    textContainer: {
        flex: 1,
        paddingRight: 10,
    },
    title: {
        fontSize: typography.h3,
        fontFamily: fonts.bold,
        color: colors.text,
        marginBottom: 6,
    },
    description: {
        fontSize: 13,
        color: colors.textSecondary,
        lineHeight: 18,
    },
    togglesContainer: {
        gap: 12,
    },
    toggleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    toggleLabel: {
        fontSize: typography.body,
        color: colors.text,
        fontFamily: fonts.body,
    },
}));

export default NotificationSettingGroup;
